var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 10.6951C20 5.17507 15.52 0.695068 10 0.695068C4.48 0.695068 0 5.17507 0 10.6951C0 15.5351 3.44 19.5651 8 20.4951V13.6951H6V10.6951H8V8.19507C8 6.26507 9.57 4.69507 11.5 4.69507H14V7.69507H12C11.45 7.69507 11 8.14507 11 8.69507V10.6951H14V13.6951H11V20.6451C16.05 20.1451 20 15.8851 20 10.6951Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.313638572148293128baa716e42c465d.svg";
export { ForwardRef as ReactComponent };